// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  url: {
    gen1: {
      base: 'https://us-central1-readymaster-development.cloudfunctions.net',
    },
    gen2: {
      prefix: 'https://',
      suffix: 'uc.a.run.app',
      project: 'd7qegcmwxa',
    },
    chainOps: {
      prefix: 'https://',
      suffix: 'uc.a.run.app',
      project: 'tspm73zrpa',
    }
  },
  gtag_measurement_id: 'G-8NQWVS299H'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
